export const LEVEL_MAP = {
  '3-4': 'entry',
  '5-6': 'simple',
  '7-8': 'developing',
  '9-11': 'fluent',
  'entry': 'entry',
  'simple': 'simple',
  'developing': 'developing',
  'fluent': 'fluent'
};

export const getLevel = (level) => {
  if (!level) return '';
  return LEVEL_MAP[level] || level;
};

export const READING_LEVELS = ['entry', 'simple', 'developing', 'fluent'];